/**
 * CodeNames.js
 *
 * This stage is a placeholder for the external CodeNames game.
 * ------------------------------------------------------------
 * - Displays the "CodeNames" title.
 * - Each player presses "Ready" once done playing.
 * - When all players have clicked ready, automatically advances to the next stage.
 */

import React, { useEffect, useState } from "react";
import { handleContinueClick, listenForAllReady } from "../helpers/stageProgressHelpers";
import Button from "../../../components/ui/Button";

const CodeNames = ({ roomID, user, players, stage, setStage }) => {
    const [hasClicked, setHasClicked] = useState(false);
    
    /**
     * 🔁 Setup listener to detect when all players are ready
     */
    useEffect(() => {
        if (!roomID || !players) return;
        const unsub = listenForAllReady(roomID, players?.length, stage, setStage);
        return () => unsub && unsub();
    }, [roomID, players, stage, setStage]);

    /**
     * ⏯ Handle "Ready" click
     */
    const handleReadyClick = async () => {
        if (hasClicked) return;
        await handleContinueClick(roomID, user, stage);
        setHasClicked(true);
    };

    return (
        <div className="w-full min-h-screen bg-black flex flex-col items-center justify-center text-white px-6 py-10 text-center">
            {/* 🧩 Title */}
            <h1 className="text-5xl sm:text-7xl font-extrabold tracking-widest mb-6">
                CodeNames
            </h1>

            {/* 💬 Subtext */}
            <p className="text-zinc-400 text-base sm:text-lg mb-12">
                Play the round externally. Click <strong>Ready</strong> once your team is done.
            </p>

            {/* ✅ Ready Button */}
            <Button
                onClick={handleReadyClick}
                variant='secondary'
            >
                {hasClicked ? "Waiting for others..." : "Ready"}
            </Button>
        </div>
    );
};

export default CodeNames;